import React from "react";
import { header, secondaryBtn } from "./ClientsList.styles";
import { hasRole } from "./api";

const OPTIONS = ["Aravete", "Ebavere", "Laatre", "Viiratsi"];

/**
 * Controlled header:
 * - selected: currently active option
 * - onSelect: handler to change selection in parent (ClientsList)
 * - onLogout: logout handler
 */


const ROLE_LABELS = {
  user: "Kasutaja",
  manager: "Haldur",
  admin: "Administraator",
};

export default function ClientsListHeader({
  selected,
  onSelect,
  onGrouping,
  onTemplates,
  onUsers,
  onChangePassword,
  onLogout,
  account,
}) {
  return (
    <div style={{ ...header}}>
      {/* Left */}
      <span>Bioforce raportid</span>

      {/* Center */}
      <div style={centerWrap}>
        <div style={segmented}>
          {OPTIONS.map((opt) => {
            const active = opt === selected;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => onSelect(opt)}
                style={active ? segBtnActive : segBtn}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>

      {/* Right */}
      <div style={rightActions}>
        <button style={secondaryBtn} onClick={onGrouping} type="button">
          Grupeering
        </button>

        <button style={secondaryBtn} onClick={onTemplates} type="button">
          Mallid
        </button>

        {hasRole(account, "admin") && (
          <button style={secondaryBtn} onClick={onUsers} type="button">
            Kasutajad
          </button>
        )}

        {account && (
          <button
            style={accountBtn}
            onClick={onChangePassword}
            type="button"
            title="Muuda parooli"
          >
            {account.username}
            <span style={roleTag}>{ROLE_LABELS[account.role] || account.role}</span>
          </button>
        )}

        <button style={secondaryBtn} onClick={onLogout} type="button">
          Logi välja
        </button>
      </div>
    </div>
  );
}

const centerWrap = {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  alignItems: "center",
};

const segmented = {
  display: "flex",
  background: "rgba(255,255,255,0.12)",
  padding: "4px",
  borderRadius: "12px",
  gap: "6px",
};

const segBtn = {
  background: "transparent",
  color: "rgba(255,255,255,0.9)",
  border: "1px solid rgba(255,255,255,0.25)",
  borderRadius: "10px",
  padding: "6px 10px",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "13px",
};

const segBtnActive = {
  ...segBtn,
  background: "#FFFFFF",
  color: "#0D1F4D",
  border: "1px solid rgba(255,255,255,0.65)",
};


const rightActions = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const accountBtn = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  background: "rgba(255,255,255,0.12)",
  color: "white",
  border: "1px solid rgba(255,255,255,0.25)",
  borderRadius: "10px",
  padding: "6px 12px",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "13px",
  fontFamily: "'DM Sans', sans-serif",
};

const roleTag = {
  fontSize: "11px",
  fontWeight: 600,
  opacity: 0.75,
};


/**
export default function ClientsListHeader({ selected, onSelect, onLogout }) {
  return (
    <div style={header}>
      <span>Bioforce raportid</span>

      <div style={rightSide}>
        <div style={segmented}>
          {OPTIONS.map((opt) => {
            const active = opt === selected;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => onSelect(opt)}
                style={active ? segBtnActive : segBtn}
              >
                {opt}
              </button>
            );
          })}
        </div>

        <button style={secondaryBtn} onClick={onLogout} type="button">
          Logi välja
        </button>
      </div>
    </div>
  );
}

/* Local styles only for the header's right side / segmented buttons *XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX/
const rightSide = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
};

const segmented = {
  display: "flex",
  background: "rgba(255,255,255,0.12)",
  padding: "4px",
  borderRadius: "12px",
  gap: "6px",
};

const segBtn = {
  background: "transparent",
  color: "rgba(255,255,255,0.9)",
  border: "1px solid rgba(255,255,255,0.25)",
  borderRadius: "10px",
  padding: "6px 10px",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "13px",
};

const segBtnActive = {
  ...segBtn,
  background: "#FFFFFF",
  color: "#0D1F4D",
  border: "1px solid rgba(255,255,255,0.65)",
};
 */
